"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInfoAlert = exports.GrayText = exports.CancelButton = exports.SuccessButton = exports.WarningButton = exports.InfoDiv = void 0;
const elements_1 = require("@src/components/elements");
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
exports.InfoDiv = styled_components_1.default.div `
	padding: 1rem 1rem 0.8rem;
	background: ${props => props.theme.color.gray2};
	border-radius: 4px;
	margin: 1rem 0 1.5rem;
`;
exports.WarningButton = (0, styled_components_1.default)(elements_1.Button) `
	background: ${props => props.theme.color.error};
	border: none;
	&:hover {
		background: ${props => props.theme.color.error};
	}
`;
exports.SuccessButton = (0, styled_components_1.default)(elements_1.Button) `
	background: ${props => props.theme.color.success};
	border: none;
	&:hover {
		background: ${props => props.theme.color.success};
	}
`;
exports.CancelButton = (0, styled_components_1.default)(elements_1.Button) `
	width: 9rem;
	justify-content: center;
`;
exports.GrayText = styled_components_1.default.span `
	color: ${props => props.theme.color.gray6};
`;
exports.StyledInfoAlert = (0, styled_components_1.default)(antd_1.Alert) `
	background-color: #e6f7ff;
	border: 1px solid #91d5ff;
	color: rgba(0, 0, 0, 0.85);
	.anticon {
		color: #1890ff;
	}
`;
